export const ANALYTICS_VARIABLE_KEY_NAME = 'GoWatchItAnalyticsObject';


// WEBPACK FOOTER //
// ./~/gwi-tracker/config/constants.js